import React, { useState, useEffect } from 'react';
import { api } from 'src/services/api';
import MatchQueueMetadata from './match-queue-metadata';
import { Loader } from '../../misc/loader-utils';

import './styles/match-queues-list.scss'

function MatchQueuesList() {

  const [queues, setQueues] = useState([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    callApiAndSetQueues()
  }, [])

  async function callApiAndSetQueues() {
    const endPoint = '/api/v2/product_match/match_queues/';
    const resp = await api.get(endPoint)
    setQueues(resp.data.data)
    setLoading(false)
  }

  return (
    <div className="match-queues-list-container">
      <div className="queues-table">
        <div className="queues-list-headers">
          <span className="queue-slug">Id</span>
          <span className="description">Description</span>
        </div>
        <div className="queues-list">
          <Loader loading={loading} />
        { queues.map(q => <MatchQueueMetadata queue={q} key={q.slug} />) }
        </div>
      </div>
    </div>
  )
}

export default MatchQueuesList
